import MainModal from "components/molecules/MainModal";
import { useNavigate } from "react-router-dom";
import FortuneWheelModalContent from "./FortuneWheelConditionsModalContent";
import "./styles.sass";

interface Props {
  isOpened: boolean;
}

const FortuneWheelConditionsModal: React.FC<Props> = ({ isOpened }) => {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <MainModal
      isOpened={isOpened}
      title="wheel.fortune.faq.header"
      onClose={handleClose}
      classNameRoot="FortuneWheelConditionsModal"
    >
      <FortuneWheelModalContent />
    </MainModal>
  );
};

export default FortuneWheelConditionsModal;
